import React, { useState } from "react";
import { useTranslation } from "../i18n/TranslationProvider";

const VIDEO_GROUPS = [
  {
    label: "June 2026",
    date: new Date(2026, 5, 1),
    videos: [
      {
        key: "travelling_admins",
        src: "https://customer-hywi166rmnzn7jfo.cloudflarestream.com/4dd9694778a88a12db44b7865bd0e7b7/iframe?poster=https%3A%2F%2Fcustomer-hywi166rmnzn7jfo.cloudflarestream.com%2F4dd9694778a88a12db44b7865bd0e7b7%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600",
      },
      {
        key: "upload_images_videos_messages",
        src: "https://customer-hywi166rmnzn7jfo.cloudflarestream.com/0993ec53c4404232867f44d04597f082/iframe?poster=https%3A%2F%2Fcustomer-hywi166rmnzn7jfo.cloudflarestream.com%2F0993ec53c4404232867f44d04597f082%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600",
      },
      {
        key: "virtual_therapist_june_25_2026",
        src: "https://customer-hywi166rmnzn7jfo.cloudflarestream.com/8b9c888ca50246403f5587a9d16e360e/iframe?poster=https%3A%2F%2Fcustomer-hywi166rmnzn7jfo.cloudflarestream.com%2F8b9c888ca50246403f5587a9d16e360e%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600",
      },
    ],
  },
  {
    label: "October 2026", // unique id for the group; displayed via `date` below
    date: new Date(2026, 9, 1),
    videos: [
      {
        key: "messages_page_new_highlight_reordering",
        src: "https://customer-hywi166rmnzn7jfo.cloudflarestream.com/84149f3f1a755b5ac334cc660d7c224c/iframe?poster=https%3A%2F%2Fcustomer-hywi166rmnzn7jfo.cloudflarestream.com%2F84149f3f1a755b5ac334cc660d7c224c%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600",
      },
      {
        key: "daily_limit_popup",
        src: "https://customer-hywi166rmnzn7jfo.cloudflarestream.com/2e8a9bc498c516e809cde00aefa8276b/iframe?poster=https%3A%2F%2Fcustomer-hywi166rmnzn7jfo.cloudflarestream.com%2F2e8a9bc498c516e809cde00aefa8276b%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600",
      },
      {
        key: "phase_complete_popup",
        src: "https://customer-hywi166rmnzn7jfo.cloudflarestream.com/e7dec17ec10779d24e0ee8ae1786d3e4/iframe?poster=https%3A%2F%2Fcustomer-hywi166rmnzn7jfo.cloudflarestream.com%2Fe7dec17ec10779d24e0ee8ae1786d3e4%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600",
      },
      {
        key: "decrement_confirm_popup",
        src: "https://customer-hywi166rmnzn7jfo.cloudflarestream.com/b29f64439a962798911668fc2974442b/iframe?poster=https%3A%2F%2Fcustomer-hywi166rmnzn7jfo.cloudflarestream.com%2Fb29f64439a962798911668fc2974442b%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600",
      },
      {
        key: "level_up_popup", 
        src: "https://customer-hywi166rmnzn7jfo.cloudflarestream.com/a779d594e01658ff5ec09d8c46d0886d/iframe?poster=https%3A%2F%2Fcustomer-hywi166rmnzn7jfo.cloudflarestream.com%2Fa779d594e01658ff5ec09d8c46d0886d%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600"
      }, 
      {
        key: "start_tracking_button_removed", 
        src: "https://customer-hywi166rmnzn7jfo.cloudflarestream.com/68dbde8d552c12f7ba9b64f7fb62dba7/iframe?poster=https%3A%2F%2Fcustomer-hywi166rmnzn7jfo.cloudflarestream.com%2F68dbde8d552c12f7ba9b64f7fb62dba7%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600"
      }
      // Add more videos here: { key: "your_key", src: "your_cloudflare_url" }
    ],
  },
  // Add more groups here: { label: "Month YYYY", date: new Date(YYYY, monthIndex, 1), videos: [...] }
];

// Renders a caption; lines starting with "- " (after a "\n") become sub-bullets
const VideoCaption = ({ text }) => {
  const [title, ...rest] = text.split("\n");
  const bullets = rest.filter((l) => l.trim().startsWith("- ")).map((l) => l.trim().slice(2));
  return (
    <div style={{ marginBottom: "0.4rem" }}>
      <p style={{ marginBottom: bullets.length ? "0.2rem" : 0 }}>{title}</p>
      {bullets.length > 0 && (
        <ul style={{ marginBottom: 0, paddingLeft: "1.5rem" }}>
          {bullets.map((b, i) => (
            <li key={i}>{b}</li>
          ))}
        </ul>
      )}
    </div>
  );
};

const NewFeatureDemos = () => {
  const { t, language } = useTranslation();

  // Localized "June 2026" / "junio de 2026" / "2026年6月"
  const formatGroupDate = (date, fallback) =>
    date ? new Intl.DateTimeFormat(language, { month: "long", year: "numeric" }).format(date) : fallback;

  // Video title keys were camelCased in en.json (e.g. travelling_admins -> travellingAdmins)
  const videoTitle = (key) =>
    t(`dashboard.resources.videoTitles.${key.toLowerCase().replace(/_(\w)/g, (_, c) => c.toUpperCase())}`);

  const [openGroups, setOpenGroups] = useState({});

  const toggleGroup = (label) => {
    setOpenGroups((prev) => ({ ...prev, [label]: !prev[label] }));
  };

  return (
    <section className="mt-4">
      <h4>{t("dashboard.resources.newFeatureDemos")}</h4>
      {VIDEO_GROUPS.map(({ label, date, videos }) => (
        <div key={label} style={{ marginBottom: "1rem" }}>
          <button
            onClick={() => toggleGroup(label)}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              background: "none",
              border: "none",
              padding: "0.4rem 0",
              cursor: "pointer",
              fontSize: "1rem",
              fontWeight: 600,
              color: "inherit",
            }}
            aria-expanded={!!openGroups[label]}
          >
            <span
              style={{
                display: "inline-block",
                transition: "transform 0.2s",
                transform: openGroups[label] ? "rotate(90deg)" : "rotate(0deg)",
              }}
            >
              ▶
            </span>
            {formatGroupDate(date, label)}
          </button>

          {openGroups[label] && (
            <div style={{ marginTop: "0.75rem" }}>
              {videos.map(({ key, src }) => (
                <div key={key} style={{ maxWidth: "480px", marginBottom: "1.5rem" }}>
                  <VideoCaption text={videoTitle(key)} />
                  <div style={{ position: "relative", paddingTop: "56.25%" }}>
                    <iframe
                      src={src}
                      loading="lazy"
                      style={{
                        border: "none",
                        position: "absolute",
                        top: 0,
                        left: 0,
                        height: "100%",
                        width: "100%",
                      }}
                      allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture"
                      allowFullScreen
                      title={videoTitle(key).split("\n")[0]}
                    />
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </section>
  );
};

export default NewFeatureDemos;